let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dodQ9")).then(() => parcelRequire('jK0tf'));